"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  Flash1: ['flash-1', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M17.848,11.306a1.023,1.023,0,0,0-.871-1.559H13.5v-9L6.152,12.689a1.022,1.022,0,0,0,.871,1.558H10.5v9Z']],
  Flash: ['flash', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M5.5,23.247l4.052-9.454a.751.751,0,0,0-.689-1.046H5.9A.749.749,0,0,1,5.21,11.7L9.8,1.2a.75.75,0,0,1,.687-.45h7.7a.75.75,0,0,1,.585,1.219l-4.05,5.063a.75.75,0,0,0,.586,1.218H18.69a.75.75,0,0,1,.53,1.281Z']],
  FlashOff: ['flash-off', 24, 24, [{
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }, {
    fill: 'none',
    stroke: '#000',
    'stroke-linecap': 'round',
    'stroke-linejoin': 'round',
    'stroke-width': '1.5'
  }], ['M16.961,12.747l.887-1.441a1.023,1.023,0,0,0-.871-1.559H13.5v-9L10.269,6', 'M7.039,11.247l-.887,1.442a1.022,1.022,0,0,0,.871,1.558H10.5v9L13.731,18', 'M2.25 2.247L21.75 21.747']]
};
exports["default"] = _default;